import { COLOR_KEYS } from 'frontend/constants';
import { useSelector } from 'react-redux';

export const useColors = () => {
  const colors = useSelector((state) => {
    const templateColors = state.applicationState.templateData.colors;
    return templateColors.length !== 0 && JSON.parse(templateColors[0].valor);
  });

  return {
    background: colors?.background || COLOR_KEYS.DEFAULT_BACKGROUND,
    defaultBackground: COLOR_KEYS.DEFAULT_BACKGROUND,
    text: colors?.text || COLOR_KEYS.DEFAULT_TEXT,
    gray: colors?.gray || COLOR_KEYS.DEFAULT_COLOR_GRAY,
    coral: COLOR_KEYS.CORAL,
  };
};
